import { render, staticRenderFns } from "./ReFlatListForBron.vue?vue&type=template&id=72db20cb&scoped=true"
import script from "./ReFlatListForBron.vue?vue&type=script&lang=js"
export * from "./ReFlatListForBron.vue?vue&type=script&lang=js"
import style0 from "./ReFlatListForBron.vue?vue&type=style&index=0&id=72db20cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db20cb",
  null
  
)

export default component.exports